(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');

  const disable = () => {
    const columns = document.querySelector('.umikaze-access-store-columns');
    if (!columns) return;
    const root = columns.parentElement;
    const media = columns.querySelector('.umikaze-access-store-media');
    const copy = columns.querySelector('.umikaze-access-store-copy');
    const locationMedia = root.querySelector(':scope > .umikaze-access-location-gallery');
    [media?.children[0], copy?.children[0], copy?.children[1], copy?.children[2], copy?.children[3], locationMedia]
      .forEach((node) => { if (node) root.insertBefore(node, columns); });
    locationMedia?.classList.remove('umikaze-access-location-gallery');
    columns.remove();
  };

  const enable = () => {
    disable();
    if (!desktopQuery.matches) return;
    const section = document.querySelector('[id$="__store_section"]');
    const root = section?.querySelector('.section-content-wrapper > .group-block > .group-block-content');
    if (!root) return;
    const nodes = {
      storeMedia: root.querySelector(':scope > .group-block'),
      storeHeading: root.querySelector(':scope > .ai-bilingual-heading[id$="storeheading"]'),
      storeBody: root.querySelector(':scope > .text-block[class*="__store_body"]'),
      locationMedia: root.querySelector(':scope > [class^="ai-image-marquee-"]'),
      locationHeading: root.querySelector(':scope > .ai-bilingual-heading[id*="locationheadingbelowstore"]'),
      locationBody: root.querySelector(':scope > .text-block[class*="__location_body_below_store"]'),
    };
    if (Object.values(nodes).some((node) => !node)) return;
    const columns = document.createElement('div');
    const media = document.createElement('div');
    const copy = document.createElement('div');
    columns.className = 'umikaze-access-store-columns';
    media.className = 'umikaze-access-store-media';
    copy.className = 'umikaze-access-store-copy';
    media.append(nodes.storeMedia);
    copy.append(nodes.storeHeading, nodes.storeBody, nodes.locationHeading, nodes.locationBody);
    columns.append(media, copy);
    nodes.locationMedia.classList.add('umikaze-access-location-gallery');
    root.append(columns, nodes.locationMedia);
  };

  desktopQuery.addEventListener('change', enable);
  document.addEventListener('shopify:section:load', enable);
  enable();
})();
